import React, { useEffect, useMemo, useRef, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { head } from 'ramda';

// store
import { storeGet, useStoreValue } from '../../store';

// api
import LookupdataService from '../../service/lookupdata-service';
import TicketService from '../../service/ticket-service';

// tools
import set404FromErrorResponse from '../../helpers/set404FromErrorResponse';
import getFormatedFileSizeText from '../../helpers/getFormatedFileSizeText';

// components
import BlockingOverlay from '../../components/BlockingOverlay';
import FormField from '../../components/FormField';
import { Button } from 'primereact/button';
import { useForm } from 'react-hook-form';
import { defaultMaxFileSize, mimeTypes, ticketsPriority } from '../../configData';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import ListTickets from './components/ListTickets';
import uniqid from '../../helpers/uniqid';


const Assistenza = () => {
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const chosenCompanyId = useStoreValue('chosenCompanyId');
    const getRole = useStoreValue('getRole');
    const companies = useStoreValue('companies');
    const existingCompany = useMemo(() => head(companies.filter(o => o.id === chosenCompanyId)), [companies, chosenCompanyId]);
    const {
        control,
        handleSubmit,
        formState: {errors},
        getValues,
        setValue,
        reset
    } = useForm({
        defaultValues: {},
        mode: 'onChange'
    });
    const toast = useRef(null);
    const refreshData = useRef(null);
    const fileUploadRef = useRef(null);
    const ticketsPriorityList = Object.keys(ticketsPriority)
        .map(key => ({label: ticketsPriority[key], name: key}));
    const values = getValues();

    const onSubmit = (formData) => {
        setLoading(true);
        const chosenCompanyId = storeGet('chosenCompanyId');
        const formDataToSend = new FormData();

        // Prepare ticketRequest (form data without files)
        const {files, ...ticketRequest} = formData;
        const jsonBlob = new Blob([JSON.stringify(ticketRequest)], {
            type: 'application/json'
        });
        formDataToSend.append('ticketRequest', jsonBlob);

        // Append files if any
        if (files && files.length > 0) {
            files.forEach((file) => {
                formDataToSend.append('files', file);
            });
        }

        TicketService.createTicket(chosenCompanyId, formDataToSend, addCallback, errAddCallback);
    };

    const addCallback = (resp) => {
        if (resp.status === 'SUCCESS') {
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: '',
                    detail: resp.message
                });
            }
            reset();
            refreshData.current = uniqid('r');
        }
        setLoading(false);
    };

    const errAddCallback = (resp) => {
        if (toast.current) {
            toast.current.show({
                severity: 'error',
                summary: '',
                detail: resp.message
            });
        }
        set404FromErrorResponse(resp);
        setLoading(false);
    };

    const getCatsCallback = (resp) => {
        if (resp.status === 'SUCCESS') {
            const cats = resp.data.map(o => ({label: o.title, name: o.id}));
            setCategories(cats);
        }
        setLoading(false);
    };

    const errGetCatsCallback = (resp) => {
    };

    useEffect(() => {
        setLoading(true);
        LookupdataService.getItems(getCatsCallback, errGetCatsCallback, [
            ['type', ['FAQ']]
        ]);
    }, []);

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Assistenza', 'htr')}</h1>
                {existingCompany ? <span className="companyName">{existingCompany.companyName}</span> : null}
            </div>

            <div className="appPage__spacer"></div>
            <Toast ref={toast}/>

            <div className="appPageSection">
                <h2>
                    {getRole === 'ROLE_CONFIDI' ? __('I miei ticket', 'htr') : __('I ticket', 'htr')}
                </h2>
                <ListTickets key={refreshData.current}/>
            </div>

            {getRole === 'ROLE_CONFIDI'
                ? <>
                    {/*<div className="appPage__spacer"></div>

                    <div className="appDocumentationInfoBox">
                        <h2>
                            {__('Guida del Portale', 'htr')}
                        </h2>
                        <p>{__('Consulta la nostra guida completa per navigare e utilizzare al meglio il portale.', 'htr')}</p>

                        <Button
                            type="button"
                            icon="pi pi-book" iconPos="right"
                            label={__('Accedi alla Guida', 'htr')}
                        />
                    </div>*/}

                    <div className="appPage__spacer"></div>

                    <div className="appPageSection">
                        <h2>
                            {__('Apri un nuovo ticket di assistenza', 'htr')}
                        </h2>
                        <form id="companyForm" className="appForm" onSubmit={handleSubmit(onSubmit)}>
                            <BlockingOverlay shouldDisplay={loading}/>
                            <div className="appPageSection">
                                <div className="appForm__cols">
                                    <FormField
                                        type="textinput"
                                        fieldName="title"
                                        label={__('Oggetto', 'htr')}
                                        control={control}
                                        errors={errors}
                                        defaultValue={values['title']}
                                        config={{required: __('È obbligatorio', 'htr')}}
                                        placeholder=""
                                    />
                                </div>

                                <div className="appForm__cols">
                                    <FormField
                                        type="select"
                                        fieldName="lookupCategoryId"
                                        label={__('Categoria', 'htr')}
                                        control={control}
                                        errors={errors}
                                        defaultValue={values['lookupCategoryId']}
                                        config={{required: __('È obbligatorio', 'htr')}}
                                        options={categories}
                                    />

                                    <FormField
                                        type="select"
                                        fieldName="priority"
                                        label={__('Priorità', 'htr')}
                                        control={control}
                                        errors={errors}
                                        defaultValue={values['priority']}
                                        config={{required: __('È obbligatorio', 'htr')}}
                                        options={ticketsPriorityList}
                                    />
                                </div>

                                <div className="appForm__cols">
                                    <FormField
                                        type="wysiwyg"
                                        fieldName="description"
                                        label={__('Descrizione del problema', 'htr')}
                                        control={control}
                                        errors={errors}
                                        defaultValue={values['description']}
                                        config={{required: __('È obbligatorio', 'htr')}}
                                    />
                                </div>

                                <div className="appForm__cols">
                                    <div className="appForm__field">
                                        <label>
                                            {__('Files', 'htr')}
                                        </label>
                                        <FileUpload
                                            ref={fileUploadRef}
                                            name="files[]"
                                            multiple
                                            accept={mimeTypes.map(o => o.code).join(',')}
                                            maxFileSize={defaultMaxFileSize}
                                            auto={false}
                                            customUpload={true}
                                            onSelect={(e) => {
                                                setValue('files', e.files);
                                            }}
                                            onRemove={() => {
                                                const updatedFiles = fileUploadRef.current.getFiles();
                                                setValue('files', updatedFiles);
                                            }}
                                            headerTemplate={(options) => {
                                                const {chooseButton} = options;
                                                return (
                                                    <div className="p-fileupload-buttonbar" data-pc-section="buttonbar">
                                                        {chooseButton}
                                                    </div>
                                                );
                                            }}
                                            chooseOptions={{
                                                label: __('Aggiungi i file', 'htr'),
                                                icon: 'pi pi-plus'
                                            }}
                                            itemTemplate={(file, props) => {
                                                return (
                                                    <div className="p-fileupload-row" data-pc-section="file">
                                                        <div data-pc-section="details" style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '10px',
                                                            textAlign: 'left'
                                                        }}>
                                                            <div className="p-fileupload-filename"
                                                                 data-pc-section="filename">
                                                                {file.name}
                                                            </div>
                                                            <span
                                                                data-pc-section="filesize">{getFormatedFileSizeText(file.size)}</span>
                                                        </div>
                                                        <div data-pc-section="actions">
                                                            <Button
                                                                type="button"
                                                                icon="pi pi-times"
                                                                className="p-button-rounded p-button-danger p-button-text"
                                                                onClick={() => props.onRemove()}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            }}
                                            emptyTemplate={<p className="m-0">{__('Trascina i file qua')}</p>}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="appPageSection">
                                <Button
                                    icon="pi pi-ticket" iconPos="left"
                                    label={__('Invia Ticket', 'htr')}
                                    disabled={loading}/>
                            </div>
                        </form>
                    </div>
                </> : null}
        </div>
    );
};

export default Assistenza;